exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info {\r\n    padding-bottom: 15px;\r\n}\t\r\n.info label {\r\n    width: 100%;\r\n}\r\n.methodEditLink {\r\n    margin-left: 10px;\r\n    cursor: pointer;\r\n}\r\n.paymentAmountGroup{\r\n    width: 350px;\r\n    margin: auto;\r\n}\r\n.paymentAmount{\r\n    width: 180px !important;\r\n}\r\n.endDateOption{\r\n    height:40px;\r\n}\r\n.endDateOptionText{\r\n    width: 200px;\r\n    display: inline-block;\r\n    float: right;\r\n}\r\n.flexRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n", ""]);

// exports
